import React from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import Account from './Account';
import { setCollapsed } from 'store/requests/global';
import { connect } from 'react-redux';

const HeaderLayout = ({ collapsed }) => {
  const onClick = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      <Button
        type="link"
        className="ToggleButton"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={onClick}
      />
      <Account />
    </>
  );
};
const mapStateToProps = (state) => ({
  collapsed: state.global.collapsed,
});

export default connect(mapStateToProps)(HeaderLayout);
